import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { ProposalActions } from './proposal.actions';
import { IProposalState } from './proposal.state';

export const initialProposalState: IProposalState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const proposalReducerFn = createReducer(
  initialProposalState,
  on(ProposalActions.reset, (state: IProposalState, action) => {
    return new StateBuilder<IProposalState>(initialProposalState).build();
  }),
  on(ProposalActions.load, (state: IProposalState, action) => {
    return new StateBuilder<IProposalState>(state).toLoading().build();
  }),
  on(ProposalActions.loadSuccess, (state: IProposalState, action) => {
    return new StateBuilder<IProposalState>(state, action).toLoaded().build();
  }),
  on(ProposalActions.submit, (state: IProposalState, action) => {
    return new StateBuilder<IProposalState>(state).toLoading().build();
  }),
  on(ProposalActions.submitSuccess, (state: IProposalState, action) => {
    return new StateBuilder<IProposalState>(state, action).toLoaded().build();
  })
);

export function proposalReducer(state: IProposalState | undefined, action: Action) {
  return proposalReducerFn(state, action);
}
